import React from "react";

import NoMatch from "../../../components/NoMatch";
import AsyncGet from "../../../components/AsyncGet";

export default function LoginRequired () {
    return (
        <AsyncGet
            url="/settings"
            permissionText={false}
            loadOnMount={true}
            showToastOnError={false}
            render={({ data }) => {
                return (
                    <NoMatch 
                        title={data.private_article_title}
                        text={data.private_article_text}
                        background={data.private_article_bg_image}
                        label={data.private_article_primary_button_label}
                        link={`/sign-in?redirect=${window.location.pathname}`}
                        secondaryButtonLabel={data.private_article_secondary_button_label}
                        secondaryButtonLink={data.private_article_secondary_button_link}
                    />
                )
            }}
        />
    )
}